import type {
    BulkOnboardingPostPublishPagePropertyOnboardingContextFieldsV1,
    BulkOnboardingPostPublishPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BulkOnboardingPostPublishPagePropertyOnboardingContextManifestV1,
    WebBulkOnboardingPostPublishPageVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/bulk-onboarding-post-publish-page";
import {
    AddNewListingElementPropertyOnboardingManifestV1,
    CannotBePublishedSectionElementPropertyOnboardingManifestV1,
    CompleteNextListingSectionElementPropertyOnboardingManifestV1,
    CompletePublishElementPropertyOnboardingManifestV1,
    ManageListingElementPropertyOnboardingManifestV1,
    ViewAllListingsElementPropertyOnboardingManifestV1,
    WhatNextSectionElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import { BaseContextFieldsMapping } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const batchPostPublishSuccessBinder = defineBinder(({ webAnalytics, action: { click, reveal, hover } }) => {
    webAnalytics.pageContext<
        BulkOnboardingPostPublishPagePropertyOnboardingContextIdsV1,
        BulkOnboardingPostPublishPagePropertyOnboardingContextFieldsV1
    >(BulkOnboardingPostPublishPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebBulkOnboardingPostPublishPageVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([reveal, click], CannotBePublishedSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], WhatNextSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], AddNewListingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], ManageListingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], CompleteNextListingSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], CompletePublishElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ViewAllListingsElementPropertyOnboardingManifestV1.ids, {});
});
